import { FeedbackFilters } from 'shared/components/Feedback/FeedbackDashboardFilterBar';
import { ApplyFilters } from 'shared/components/Feedback/FiltersDropdown/ShowFilter';

export const tempDonorName: FeedbackFilters = {
  'Donor Name 1': {
    name: 'Donor Name 1',
    count: 14,
  },
  'Donor Name 2': {
    name: 'Donor Name 2',
    count: 14,
  },
  'Donor Name 3': {
    name: 'Donor Name 3',
    count: 14,
  },
  'Donor Name 4': {
    name: 'Donor Name 4',
    count: 14,
  },
  'Donor Name 5': {
    name: 'Donor Name 5',
    count: 14,
  },
  'Donor Name 6': {
    name: 'Donor Name 6',
    count: 14,
  },
  'Donor Name 7': {
    name: 'Donor Name 7',
    count: 14,
  },
  'Donor Name 8': {
    name: 'Donor Name 8',
    count: 14,
  },
  'Donor Name 9': {
    name: 'Donor Name 9',
    count: 14,
  },
  'Donor Name 10': {
    name: 'Donor Name 10',
    count: 14,
  },
  'Donor Name 11': {
    name: 'Donor Name 11',
    count: 14,
  },
  'Donor Name 12': {
    name: 'Donor Name 12',
    count: 14,
  },
  'Donor Name 13': {
    name: 'Donor Name 13',
    count: 14,
  },
  'Donor Name 14': {
    name: 'Donor Name 14',
    count: 14,
  },
  'Donor Name 15': {
    name: 'Donor Name 15',
    count: 14,
  },
};

export const tempCycleType: FeedbackFilters = {
  'True Impact Only': {
    name: 'True Impact Only',
  },
  'Donor Only': {
    name: 'Donor Only',
  },
  'True Impact & Donor': {
    name: 'True Impact & Donor',
  },
};

export const tempStatus: (
  userType: 'donor' | 'TI staff' | undefined,
) => FeedbackFilters = (userType: 'donor' | 'TI staff' | undefined) => ({
  Draft: {
    name: 'Draft',
  },
  'Awaiting TI Feedback': {
    name: 'Awaiting TI Feedback',
    selected: userType === 'TI staff',
  },
  'TI Feedback Provided': {
    name: 'TI Feedback Provided',
  },
  'Awaiting TI Verification': {
    name: 'Awaiting TI Verification',
    selected: userType === 'TI staff',
  },
  'Awaiting Funder Feedback': {
    name: 'Awaiting Funder Feedback',
    selected: userType === 'donor',
  },
  'Funder Feedback Provided': {
    name: 'Funder Feedback Provided',
  },
  'Awaiting Funder Verification': {
    name: 'Awaiting Funder Verification',
    selected: userType === 'donor',
  },
  Published: {
    name: 'Published',
  },
  Finalized: {
    name: 'Finalized',
  },
});

export const tempTrueImpactStaff: FeedbackFilters = {
  'Sara Ansell': {
    name: 'Sara Ansell',
  },
  'Rebecca Cook Dorman': {
    name: 'Rebecca Cook Dorman',
  },
  'Sadie Miller': {
    name: 'Sadie Miller',
  },
  'Chelsea Takamine': {
    name: 'Chelsea Takamine',
  },
};

export const tempDueDate = (): FeedbackFilters => ({
  'Less than 1 day': {
    name: 'Less than 1 day',
  },
  'Less than 7 days': {
    name: 'Less than 7 days',
  },
  'Less than 1 month': {
    name: 'Less than 1 month',
  },
  'Less than 1 year': {
    name: 'Less than 1 year',
  },
  'Greater than 1 year': {
    name: 'Greater than 1 year',
  },
});

export const tempCharityNavigator: FeedbackFilters = {
  'Charity Navigator': {
    name: 'Charity Navigator',
  },
};

export const tempYear = (): { [key: string]: { name: string } } => {
  const currentYear = new Date().getFullYear();
  const years = new Array(currentYear + 3 - 2007);
  const result: { [key: string]: { name: string } } = {};
  for (const year of Array.from(years.keys())) {
    result[`${2007 + year}`] = { name: `${2007 + year}` };
  }
  return result;
};

export const tempDonorSortBy: () => FeedbackFilters = () => ({
  'Program Name by A-Z': {
    name: 'Program Name by A-Z',
    value: 'NAME_ASC',
  },
  'Due Date': {
    name: 'Due Date',
    value: 'NAME_ASC',
  },
});

export const tempAdminSortBy: () => FeedbackFilters = () => ({
  'Program Name by A-Z': {
    name: 'Program Name by A-Z',
    value: 'NAME_ASC',
  },
  'Donor Name by A-Z': {
    name: 'Donor Name by A-Z',
    value: 'DONOR_NAME_ASC',
  },
  'TI Staff Name by A-Z': {
    name: 'TI Staff Name by A-Z',
    value: 'NAME_ASC',
  },
  'Due Date': {
    name: 'Due Date',
    value: 'END_DATE_DESC',
  },
  'Last Update': {
    name: 'Last Update',
    value: 'CREATED_AT_DESC',
  },
});

export interface LoadFilters extends ApplyFilters {
  id: number | string;
  filterName: string;
  createdDate: string;
  usersName: string;
}

export interface LoadFiltersApi {
  personal: LoadFilters[];
  organizational: LoadFilters[];
}

export const loadFilters: LoadFiltersApi = {
  personal: [
    {
      id: 1,
      filterName: 'PepsiCo - Sara and Sadie',
      createdDate: '07/14/21',
      usersName: 'Sara Ansell',
      relationshipFilters: {},
      portfolioNameFilters: {},
      donorNameFilters: {
        'Donor Name 6': {
          name: 'Donor Name 6',
          selected: true,
        },
        'Donor Name 7': {
          name: 'Donor Name 7',
          selected: true,
        },
      },
      cyclesFilters: {
        'True Impact Only': {
          name: 'True Impact Only',
          selected: true,
        },
      },
      statusFilters: {
        'Awaiting NPO Verification': {
          name: 'Awaiting NPO Verification',
          selected: true,
        },
      },
      staffFilters: {
        'Sara Ansell': {
          name: 'Sara Ansell',
          selected: true,
        },
        'Sadie Miller': {
          name: 'Sadie Miller',
          selected: true,
        },
      },
      dueDateFilters: {
        'Less than 7 days': {
          name: 'Less than 7 days',
          selected: true,
        },
      },
      charityNavigatorFilters: {},
      yearFilters: {},
    },
    {
      id: 2,
      filterName: 'PepsiCo - Rebecca and Robin',
      createdDate: '05/14/21',
      usersName: 'Rebecca Dorman',
      relationshipFilters: {},
      portfolioNameFilters: {},
      donorNameFilters: {
        'Donor Name 1': {
          name: 'Donor Name 1',
          selected: true,
        },
        'Donor Name 10': {
          name: 'Donor Name 10',
          selected: true,
        },
      },
      cyclesFilters: {
        'True Impact & Donor': {
          name: 'True Impact & Donor',
          selected: true,
        },
      },
      statusFilters: {
        'Awaiting Funder Feedback': {
          name: 'Awaiting Funder Feedback',
          selected: true,
        },
        ['Completed']: {
          name: 'Completed',
          selected: true,
        },
      },
      staffFilters: {
        'Rebecca Dorman': {
          name: 'Rebecca Dorman',
          selected: true,
        },
        'Robin Hesse': {
          name: 'Robin Hesse',
          selected: true,
        },
      },
      dueDateFilters: {
        'Less than 1 year': {
          name: 'Less than 1 year',
          selected: true,
        },
      },
      charityNavigatorFilters: {},
      yearFilters: {},
    },
  ],
  organizational: [
    {
      id: 3,
      filterName: 'TrueImpact - Emily and Chelsea',
      createdDate: '06/14/21',
      usersName: 'Emily Hollerbach',
      relationshipFilters: {},
      portfolioNameFilters: {},
      donorNameFilters: {
        'Donor Name 8': {
          name: 'Donor Name 8',
          selected: true,
        },
        'Donor Name 7': {
          name: 'Donor Name 7',
          selected: true,
        },
      },
      cyclesFilters: {
        'Donor Only': {
          name: 'Donor Only',
          selected: true,
        },
      },
      statusFilters: {
        'Awaiting TI Feedback': {
          name: 'Awaiting TI Feedback',
          selected: true,
        },
      },
      staffFilters: {
        'Emily Hollerbach': {
          name: 'Emily Hollerbach',
          selected: true,
        },
        'Chelsea Takamine': {
          name: 'Chelsea Takamine',
          selected: true,
        },
      },
      dueDateFilters: {
        'Less than 1 day': {
          name: 'Less than 1 day',
          selected: true,
        },
      },
      charityNavigatorFilters: {},
      yearFilters: {},
    },
    {
      id: 4,
      filterName: 'TrueImpact - Yuvi and Dipali',
      createdDate: '08/14/21',
      usersName: 'Yuvi Koul',
      relationshipFilters: {},
      portfolioNameFilters: {},
      donorNameFilters: {
        'Donor Name 13': {
          name: 'Donor Name 13',
          selected: true,
        },
        'Donor Name 11': {
          name: 'Donor Name 11',
          selected: true,
        },
      },
      cyclesFilters: {
        'Donor Only': {
          name: 'Donor Only',
          selected: true,
        },
      },
      statusFilters: {
        'Awaiting TI Feedback': {
          name: 'Awaiting TI Feedback',
          selected: true,
        },
      },
      staffFilters: {
        'Yuvi Koul': {
          name: 'Yuvi Koul',
          selected: true,
        },
        'Dipali Lohar': {
          name: 'Dipali Lohar',
          selected: true,
        },
      },
      dueDateFilters: {
        'Less than 1 month': {
          name: 'Less than 1 month',
          selected: true,
        },
      },
      charityNavigatorFilters: {},
      yearFilters: {},
    },
    {
      id: 5,
      filterName: 'TrueImpact - Yuvi and Dipali',
      createdDate: '08/14/21',
      usersName: 'Yuvi Koul',
      relationshipFilters: {},
      portfolioNameFilters: {},
      donorNameFilters: {
        'Donor Name 13': {
          name: 'Donor Name 13',
          selected: true,
        },
        'Donor Name 11': {
          name: 'Donor Name 11',
          selected: true,
        },
      },
      cyclesFilters: {
        'Donor Only': {
          name: 'Donor Only',
          selected: true,
        },
      },
      statusFilters: {
        'Awaiting TI Feedback': {
          name: 'Awaiting TI Feedback',
          selected: true,
        },
      },
      staffFilters: {
        'Yuvi Koul': {
          name: 'Yuvi Koul',
          selected: true,
        },
        'Dipali Lohar': {
          name: 'Dipali Lohar',
          selected: true,
        },
      },
      dueDateFilters: {
        'Less than 1 month': {
          name: 'Less than 1 month',
          selected: true,
        },
      },
      charityNavigatorFilters: {},
      yearFilters: {},
    },
  ],
};
